export class DirtyWildsStrings {

    public static FS_YOU_WON_TEXT:string = "You won";
    public static FS_SPINS_PLAYED:string = "Spins played: ";
}